import React from 'react'
import Skeleton from 'react-loading-skeleton'

const CardSkeleton = () => {
  return <Skeleton height={36} />
}

export default CardSkeleton
